import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AvailableLeads from "./pages/AvailableLeads";
import LeadDetails from "./pages/LeadDetails";
import BidLeadPage from "./pages/BidLeadPage";  

export default function App() {
  return (
    
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/available-leads" element={<AvailableLeads />} />
        <Route path="/lead/:estimateId" element={<LeadDetails />} />
        <Route path="/bid-lead/:estimateId" element={<BidLeadPage />} />
      </Routes>
    </BrowserRouter>
  );
}
